module.exports = __webpack_public_path__ + "static/img/car.370bf824.png";